import type { ChartWidget as ChartWidgetType } from '../../types/coach';
import { Card, Icon } from '../atoms';
import { ErrorState } from '../molecules';

interface ChartWidgetProps {
  widget: ChartWidgetType;
}

export function ChartWidget({ widget }: ChartWidgetProps) {
  const { chart } = widget;

  // Defensive programming
  if (!chart) {
    return <ErrorState message="Invalid chart widget" />;
  }

  return (
    <Card variant="glass" hover size="lg" className="max-w-lg">
      <div className="mb-4">
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
            <Icon name="dashboard" size="sm" className="text-white" />
          </div>
          <div>
            <h4 className="text-sm font-semibold text-text-primary">Data Visualization</h4>
            <p className="text-xs text-text-muted">Interactive chart</p>
          </div>
        </div>
      </div>

      <div className="border border-border-separator rounded-lg overflow-hidden bg-bg-surface">
        {chart.format === 'svg' ? (
          <div 
            className="w-full h-64 flex items-center justify-center p-4"
            dangerouslySetInnerHTML={{ 
              __html: atob(chart.data) 
            }}
          />
        ) : (
          <div className="w-full h-64 flex items-center justify-center text-text-disabled">
            <div className="text-center">
              <Icon name="dashboard" size="xl" className="mx-auto mb-3" />
              <p className="text-sm font-medium">Chart visualization</p>
              <p className="text-xs mt-1">Data format: {chart.format}</p>
            </div>
          </div>
        )}
      </div>
    </Card>
  );
}